<template>
  <v-row dense>
    <v-col cols="12">
      <int-editor ref="item_mobile" validate-on-blur v-model="data.mobile" dense outlined class="rounded-0" autocomplete="off" label="手机号" :rules="rules.mobile" @keydown.native="onMobileKeydown"></int-editor>
    </v-col>
    <v-col cols="12">
      <int-editor ref="item_smsCode" validate-on-blur v-model="data.smsCode" dense label="验证码" outlined class="rounded-0" autocomplete="off" :rules="rules.smsCode" @keydown.native="onSmsCodeKeydown">
        <template v-slot:append>
          <div style="margin-top:-3px;">
            <v-btn color="primary" small class="caption" :disabled="smsCodeDisabled" elevation=0 @click="onGetLoginSmsCode">{{smsCodeText}}</v-btn>
          </div>
        </template>
      </int-editor>
    </v-col>
    <v-col cols="12" v-if="loginVerifyCode">
      <v-row dense>
        <v-col cols="7">
          <v-text-field ref="item_verifyCode" validate-on-blur v-model="data.verifyCode" dense outlined class="rounded-0" autocomplete="off" label="图片验证码" :rules="rules.verifyCode" @keydown.native="onVerifyCodeKeydown"></v-text-field>
        </v-col>
        <v-col cols="5">
          <v-img :src="verifyCodeUrl" @click="onRefreshVerifyCode" contain height="37"></v-img>
        </v-col>
      </v-row>
    </v-col>
  </v-row>

</template>
<script>
/* eslint-disable no-console */
import { getLoginSmsCode } from '@/plugins/api';
import { required, mobile } from '@/plugins/rules';

export default {
  props: {
    loginVerifyCode: { type: Boolean, default: false }
  },
  data () {
    return {
      data: {},
      verifyCodeUrl: `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`,
      smsCodeText: '获取验证码',
      smsCodeDisabled: false,
      rules: {
        mobile: [required(), mobile()],
        smsCode: [required()],
        verifyCode: [required()]
      }
    }
  },
  methods: {
    getLoginData () {
      return this.Utility.clone(this.data);
    },
    validate () {
      if (!this.data.mobile) return '请填写注册手机号';
      if (!this.data.smsCode) return '请填写登录密码';
      if (this.loginVerifyCode && !this.data.verifyCode) return '请输入图片验证码';
      return true;
    },
    onMobileKeydown (e) {
      if (e.keyCode == 13) this.$refs.item_smsCode.focus();
    },
    onSmsCodeKeydown (e) {
      if (e.keyCode == 13) {
        if (this.loginVerifyCode) {
          this.$refs.item_verifyCode.focus();
        } else {
          this.$emit('login');
        }
      }
    },
    onVerifyCodeKeydown (e) {
      if (e.keyCode == 13) {
        this.$emit('login');
      }
    },
    onRefreshVerifyCode () {
      this.verifyCodeUrl = `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`;
    },
    onGetLoginSmsCode () {
      if (!this.data.mobile) {
        this.$emit('error', '请填写注册手机号');
        return;
      }
      this.smsCodeDisabled = true;
      let i = 60;
      let removeTimer = () => {
        clearInterval(smsCodeTimer);
        smsCodeTimer = undefined;
        this.smsCodeDisabled = false;
        this.smsCodeText = '获取验证码';
      }
      let smsCodeTimer = setInterval(() => {
        if (i < 0) removeTimer();
        else this.smsCodeText = `重新发送${i--}`;
      }, 1000);
      getLoginSmsCode(this.data.mobile).then((res) => {
        if (res.status < 0) {
          this.$emit('error', res.message);
          removeTimer();
          return;
        }
        this.$message.success('验证码已发送，请注意查收');
      })
    }
  }
}
  </script>